<template>
  <div v-if="selectedSubscription">
    <!-- Load Subscription based on name -->
    <sign-up
      :title=selectedSubscription.title
      signUpSharedUsers
      :subscriptionID=selectedSubscription.id
    >
      <template v-slot:pricing> </template>
    </sign-up>
  </div>

  <v-container id="app" fluid class="fill-height" v-else-if="selectedSubscription === null">
    <v-row align="center">
      <v-col md="1"></v-col>
      <v-col cols="12" md="4">
        <div>
          <div class="display-1 my-3 text-center">Subscription is No Longer Valid</div>
          <div><a href="/sign-up/sales-pro" class="text--primary">Start Over</a></div>
        </div>
      </v-col>
      <v-col md="7" class="d-none d-md-flex background">
        <img src="@/assets/woman_jumping.png" alt="Woman Jumping"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { describeError } from "@/utils/safeErrorLog";
import store from "@/store";
import helpers from "@/mixins/helpers";
import SignUpModule from "./SignUpModule.vue";
import FloatingMessage from "../FloatingMessage.vue";

export default {
  components: {
    "sign-up": SignUpModule,
    "floating-message": FloatingMessage,
  },
  data() {
    return {
      selectedSubscription: null
    };
  },

  mixins: [helpers],

  computed: {},

  async mounted() {
    this.$nextTick(async () => {
      await this.loadSubscription();
    });
  },

  methods: {
    async loadSubscription() {
      try {
        let subscriptionName =  this.$route.params.id;
        if(!subscriptionName) {
          subscriptionName ="sales-pro";
        }

        let response = await this.$axios.get(`/auth/getSubscriptionByName/`+subscriptionName);
        this.selectedSubscription = response.data;
      } catch (err) {
        console.log(describeError(err));
      }
    }
  },
};
</script>

<style scoped>
</style>


